import { Flex, Text, type TextProps } from '@chakra-ui/react'
import React, { useMemo } from 'react'

import {
  MenuItemStyleValues,
  useMenuItemStyles,
} from '../componentStyles/MenuItem.style'

export type MenuItem<TValue> = {
  value: TValue
  content: string | React.JSX.Element
  onSelect?: (value: TValue, index: number) => void
  clickDisabled?: boolean
}

type MenuItemProps = {
  // TODO: support for selected checkmark
  width?: string
  hide?: boolean
} & (
  | {
      primaryText: string
      secondaryText?: string
      secondaryTextClamp?: number
      secondaryTextProps?: Omit<TextProps, 'children'>
      leftContent?: React.ReactNode
      rightContent?: React.ReactNode
      isDestructive?: boolean
      children?: never
    }
  | {
      primaryText?: never
      secondaryText?: never
      secondaryTextClamp?: never
      secondaryTextProps?: never
      leftContent?: never
      rightContent?: never
      isDestructive?: never
      children: React.ReactNode
    }
)

export const MenuListItem = ({
  width,
  primaryText,
  secondaryText,
  secondaryTextClamp,
  secondaryTextProps,
  leftContent,
  rightContent,
  isDestructive,
  children,
}: MenuItemProps) => {
  const styles = useMenuItemStyles()

  const itemContent = useMemo(() => {
    if (!children) {
      return (
        <Flex css={styles.itemContainer}>
          {leftContent}
          <Flex css={styles.textContainer}>
            <Text
              css={!isDestructive ? styles.primaryText : styles.destructiveText}
              lineClamp={1}
            >
              {primaryText}
            </Text>
            {secondaryText && (
              <Text
                css={styles.secondaryText}
                {...(secondaryTextClamp
                  ? { lineClamp: secondaryTextClamp }
                  : {})}
                {...secondaryTextProps}
              >
                {secondaryText}
              </Text>
            )}
          </Flex>
          {rightContent}
        </Flex>
      )
    } else {
      return children
    }
  }, [children])

  return (
    <Flex
      css={styles.outerContainer}
      width={width ?? MenuItemStyleValues.defaultOuterContainerWidth}
    >
      {itemContent}
    </Flex>
  )
}
